module.exports = __webpack_public_path__ + "static/media/shop.c7a64827.webp";